module.exports = __webpack_public_path__ + "img/3dStitchedBag03.018fc53f.jpg";